<template>
  <div>
    <p
      v-if="message !== ''"
      role="alert"
      data-checkout-field="store_id"
      class="dark:text-danger-400 my-2 text-danger-600 text-sm"
    >
      {{ message }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useCurrencyFormat } from '~/composables/useCurrencyFormat'
import { usePresentationTranslator } from '~/composables/usePresentationTranslator'

const props = defineProps<{
  /** The store's order minimum; 0 when it has none. */
  minimum: number
  /** What the subtotal still needs to reach the minimum; 0 when met. */
  shortfall: number
  /** A server verdict on the order total, shown in place of the live shortfall. */
  error?: string
}>()

const t = usePresentationTranslator()
const formatCurrency = useCurrencyFormat()

const message = computed(() => {
  if (props.error !== undefined && props.error !== '') return props.error
  return props.shortfall > 0
    ? t('commerce.orderMinimumNotice.shortfall', {
        minimum: formatCurrency(props.minimum),
        shortfall: formatCurrency(props.shortfall)
      })
    : ''
})
</script>
